import { useQueryClient } from '@tanstack/react-query';
import {
  useAcceptModuleVersionUpgrade,
  useDismissModuleVersionUpgrade,
} from '@/common/api/endpoints/course-modules/course-modules';
import { getGetModulesQueryKey } from '@/common/api/endpoints/modules/modules';
import { refreshStudentModuleAfterVersionChange } from '@/common/hooks/student/module/refreshStudentModuleAfterVersionChange';

const invalidateModules = (queryClient: ReturnType<typeof useQueryClient>) => {
  queryClient.invalidateQueries({ queryKey: getGetModulesQueryKey() });
};

export const useModuleUpgradeMutations = () => {
  const queryClient = useQueryClient();
  const acceptMutation = useAcceptModuleVersionUpgrade({
    mutation: {
      onSuccess: async (_data, variables) => {
        await refreshStudentModuleAfterVersionChange(queryClient, {
          courseId: variables.courseId,
          moduleId: variables.moduleId,
        });
      },
    },
  });
  const dismissMutation = useDismissModuleVersionUpgrade({
    mutation: { onSuccess: () => invalidateModules(queryClient) },
  });

  return { acceptMutation, dismissMutation };
};
